var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 105,
    viewBox: "0 0 120 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1393 95.8939C92.862 95.8939 112.904 75.8507 112.904 51.1262C112.904 26.4016 92.862 6.3584 68.1393 6.3584C43.4167 6.3584 23.375 26.4016 23.375 51.1262C23.375 75.8507 43.4167 95.8939 68.1393 95.8939Z",
    fill: "#EDEBDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5312 99.8242L57.896 102.189",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 91.5459L49.6147 93.9108",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5312 93.9108L57.896 91.5459",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 102.189L49.6147 99.8242",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6582 10.2515C87.808 10.2515 89.5507 8.50863 89.5507 6.35867C89.5507 4.20871 87.808 2.46582 85.6582 2.46582C83.5084 2.46582 81.7656 4.20871 81.7656 6.35867C81.7656 8.50863 83.5084 10.2515 85.6582 10.2515Z",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4844 7.71582V10.47",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4844 18.7305V21.4847",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5977 14.5996H25.3497",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6094 14.5996H36.3634",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5093 6.3588C20.1216 6.3588 21.4287 5.05164 21.4287 3.43917C21.4287 1.8267 20.1216 0.519531 18.5093 0.519531C16.8969 0.519531 15.5898 1.8267 15.5898 3.43917C15.5898 5.05164 16.8969 6.3588 18.5093 6.3588Z",
    fill: "#4C241D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5679 103.68C18.1802 103.68 19.4873 102.373 19.4873 100.76C19.4873 99.148 18.1802 97.8408 16.5679 97.8408C14.9555 97.8408 13.6484 99.148 13.6484 100.76C13.6484 102.373 14.9555 103.68 16.5679 103.68Z",
    fill: "#4C241D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6244 78.3763H1.96875V31.6621H107.068V78.3763H89.5511",
    fill: "#A9BA5A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6244 78.3763H1.96875V31.6621H107.068V78.3763H89.5511",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5204 72.5376C64.1945 72.5376 72.0369 64.6946 72.0369 55.0198C72.0369 45.3449 64.1945 37.502 54.5204 37.502C44.8463 37.502 37.0039 45.3449 37.0039 55.0198C37.0039 64.6946 44.8463 72.5376 54.5204 72.5376Z",
    fill: "#FFEC95"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1639 37.502H17.54C17.54 40.0831 16.5147 42.5585 14.6897 44.3836C12.8647 46.2087 10.3895 47.2341 7.80859 47.2341V60.859",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75487 41.3948C10.8298 41.3948 11.7011 40.5234 11.7011 39.4484C11.7011 38.3734 10.8298 37.502 9.75487 37.502C8.67997 37.502 7.80859 38.3734 7.80859 39.4484C7.80859 40.5234 8.67997 41.3948 9.75487 41.3948Z",
    fill: "#4C241D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2831 103.68C110.032 103.68 118.746 94.966 118.746 84.2162C118.746 73.4664 110.032 64.752 99.2831 64.752C88.5341 64.752 79.8203 73.4664 79.8203 84.2162C79.8203 94.966 88.5341 103.68 99.2831 103.68Z",
    fill: "#FFCE56",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2841 97.8408C106.808 97.8408 112.908 91.7407 112.908 84.2158C112.908 76.6909 106.808 70.5908 99.2841 70.5908C91.7598 70.5908 85.6602 76.6909 85.6602 84.2158C85.6602 91.7407 91.7598 97.8408 99.2841 97.8408Z",
    stroke: "#FFEC95",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6269 64.7514V45.2871H57.4389C58.7294 45.2871 59.967 45.7998 60.8795 46.7123C61.7919 47.6249 62.3046 48.8626 62.3046 50.1532C62.3046 51.4437 61.7919 52.6814 60.8795 53.594C59.967 54.5066 58.7294 55.0192 57.4389 55.0192H46.7344",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7344 60.8584H58.412",
    stroke: "#4C241D",
    strokeWidth: 2.4522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c0aa8fa02106b9ba9f399e66620cfed1.svg";
export { ForwardRef as ReactComponent };